// extracted by mini-css-extract-plugin
module.exports = {"circle-md":"styles-module__circle-md___Ch-5S","circle-lg":"styles-module__circle-lg___2IMJU","circle-xl":"styles-module__circle-xl___2TomI"};